export default "__VITE_ASSET__fc687a18__"